var map = {
	"./app/apple.svg": "5a28",
	"./app/google.svg": "5d32",
	"./arrow/chevron-left.svg": "edc6",
	"./arrow/chevron-right.svg": "da08",
	"./filetypes/archive.svg": "b0c1",
	"./filetypes/audio.svg": "533e",
	"./filetypes/doc.svg": "da21",
	"./filetypes/img.svg": "54b1",
	"./filetypes/pdf.svg": "de3c",
	"./filetypes/presentation.svg": "cdc5",
	"./filetypes/share.svg": "13a9",
	"./filetypes/sheet.svg": "ca21",
	"./filetypes/unknown.svg": "edb0",
	"./filetypes/video.svg": "2d22",
	"./loading/bars.svg": "3c55",
	"./loading/spinner.svg": "c80b",
	"./media/full.svg": "883b",
	"./media/pause.svg": "8507",
	"./media/play.svg": "cf7e",
	"./preview/download.svg": "c123",
	"./preview/rotate.svg": "a938",
	"./preview/search.svg": "11fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32e0";